import { Injectable } from '@angular/core';
import {SearchContainer} from "./definitions/search-container";
import {SearchObject} from "./definitions/search-object";

@Injectable({
  providedIn: 'root',
})
export class SearchResultSelectionsSorter {
sortItems(searchContainer: SearchContainer) {
  const orderParts = searchContainer.getOrder() ? searchContainer.getOrder().split(' ') : [];
  if (orderParts.length >= 1) {
    const sortField = orderParts[0];
    const sortDirection = (orderParts.length >= 2 && orderParts[1].toLowerCase() === 'desc') ? -1 : 1;
    const items = searchContainer.selections.selectedItems;

    // Precompute sort values
    const sortValueMap = new Map<SearchObject, any>();
    for (const item of items) {
      sortValueMap.set(item, this.getSortFieldValue(item, sortField));
    }

    items.sort((a, b) => {
      const aValue = sortValueMap.get(a);
      const bValue = sortValueMap.get(b);
      if (aValue < bValue) return -1 * sortDirection;
      if (aValue > bValue) return 1 * sortDirection;
      return 0;
    });
  }
}

  private getSortFieldValue(item: SearchObject, sortField: string): any {
    let value = item[sortField];
    if (value === undefined) {
      // Value may be found in item.overview[].items[].field_values<FieldValues>.values[].value.
      // Check first that one of the overview fields has a field_name starting with the sortField value.
      if (item.overview && item.overview.length) {
        for (const overviewField of item.overview) {
          if (overviewField.field_name && sortField.startsWith(overviewField.field_name) &&
            overviewField.items && overviewField.items.length) {
            const fieldValues = overviewField.items[0].field_values;
            if (fieldValues && fieldValues.values && fieldValues.values.length) {
              value = fieldValues.values[0].value;
              break;
            }
          }
        }
      }
    }
    return value;
  }

}
